module.exports = __webpack_public_path__ + "images/emoji/purse.aa3ef7af55505d609fb1.png";